<script>
export default {
    name: 'design-2021-magazine-parent-url-deadline-modal-component',
    props: {
        magazineId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            modal: false,
            deadline: {
                date: null,
                time: null,
            },
        };
    },
    methods: {
        show(deadline) {
            this.deadline = deadline;
            this.modal = true;
        },
        storeDeadline() {
            const data = {
                parent_page_deadline: this.deadline.date + ' ' + this.deadline.time,
            };

            this.alert.saving();
            this.axios.post(this.routes.magazineParentPageDeadlineUpdate(this.magazineId), data).then(
                (response) => {
                    this.$emit('deadline-updated', response.data.parent_page_deadline);
                    // this.deadlineEdit = false;
                    // this.magazine.parent_page_deadline = response.data.parent_page_deadline;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<template>
    <b-modal
        v-model="modal"
        :title="$t('magazine.set_deadline')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="storeDeadline"
        modal-class="apprentice-default-modal">
        <div class="set-deadline">
            <b-form-datepicker
                class="apprentice-date-picker deadline-date-group"
                id="group-edit-startdate-picker"
                v-model="deadline.date"
                start-weekday="1"
                now-button
                reset-button
                right
                locale="nl"
                :aria-controls="$t('group.choose_date')"
                label-reset-button="reset"
                today-variant="primary"
                nav-button-variant="primary"
                :label-no-date-selected="$t('group.no_date_selected')"
                menu-class="datedropdown"
                :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }">
            </b-form-datepicker>

            <design-2021-apprentice-timepicker-component
                class="deadline-time-group"
                v-model="deadline.time">
            </design-2021-apprentice-timepicker-component>
        </div>
    </b-modal>
</template>

<style scoped lang="scss">
.set-deadline {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: $grid-gutter-width;
}

.deadline-date-group {
    flex: 1 0 calc(75% - 15px);
}

.deadline-time-group {
    flex: 1 0 calc(25% - 15px);
}
</style>
